<template>
  <v-container fluid px-0>
    <v-layout justify-center align-center mx-5 mt-3>
      <v-flex md12 class="headline" v-if="workflow.status === 'Activo'">
        {{workflow.name}}
      </v-flex>
      <v-flex md12 class="headline grey--text" v-else>
        {{workflow.name}}
        <v-chip small class="white--text grey">
          <v-icon class="pr-2" small>fas fa-times</v-icon>
          {{workflow.status}}
        </v-chip>
      </v-flex>
    </v-layout>
    <template v-if="workflowNotifications.length > 0 && render">
      <template v-for="(item, i) in workflowNotifications">
        <v-layout row wrap :class="{'mx-5':true, 'mt-3':i === 0}" :key="i">
          <v-flex md12>
            <v-card v-if="editWorkflow !== item.id" class="x-borders-radius">
              <v-card-text>
                <v-layout justify-center align-center class="mb-3">
                  <v-flex md12 class="pl-2 f1-4em" v-if="item.status === 'Activo'">
                    {{item.name}}
                    <v-layout row wrap class="f0-8em grey--text">
                      <v-flex md12>
                        Ventana de tiempo: {{item.days_off}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md12 class="pl-2 f1-4em grey--text" v-else>
                    {{item.name}}
                    <v-chip small class="white--text grey" v-if="workflow.status === 'Activo'">
                      <v-icon class="pr-2" small>fas fa-times</v-icon>
                      {{item.status}}
                    </v-chip>
                    <v-layout row wrap class="f0-8em grey--text">
                      <v-flex md12>
                        Ventana de tiempo: {{item.days_off}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md4 class="f1-5em text-xs-right">
                    <v-menu offset-x>
                      <v-btn slot="activator" class="" icon>
                        <v-icon small>fas fa-ellipsis-v</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile @click="changeStatus(item.id, item.status === 'Activo' ? 'Inactivo' : 'Activo')" v-if="workflow.status === 'Activo'">
                          <v-list-tile-title>{{item.status === 'Activo' ? 'Desactivar' : 'Activar'}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile  @click="editWorkflow = item.id">
                          <v-list-tile-title>Editar</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile  @click="deleteWorkflow(item.id, item.name, item.workflow_filters.length)">
                          <v-list-tile-title>Eliminar</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <template v-if="showFilters !== item.id">
                  <v-layout justify-center align-center my-3>
                    <v-flex md12 class="text-xs-center">
                      <v-btn flat large icon @click="showFilters = item.id">
                        <v-icon>fas fa-angle-down</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
                <!-- Filters OF Filter -->
                <template v-else>
                  <draggable v-model="item.workflow_filters" :options="{group:'people'}" @change="drag($event, i)">
                    <template v-for="(row, j) in item.workflow_filters">
                        <v-layout justify-center align-center class="px-3 pt-2 mx-4 mb-3 a-borders x-borders-radius hovereable" :key="row.id">
                          <v-flex md1>
                            <v-icon class="mb-1 ml-3 f3-5em k-orange-linear-text">fas fa-code-branch fa-rotate-180</v-icon>
                          </v-flex>
                          <v-flex md10>
                            <v-layout row wrap>
                              <v-flex md12>
                                <v-layout justify-center align-center pb-2>
                                  <v-flex md7 class="f1-3em" px-2 v-if="editDetail !== row.id && row.status === 'Activo'">
                                    {{row.name}}
                                    <v-btn icon small @click="editDetail = row.id" class="grey--text">
                                      <v-icon small class="f0-9em">fas fa-pencil-alt</v-icon>
                                    </v-btn>
                                  </v-flex>
                                  <v-flex md9 class="f1-3em grey--text" px-2 v-if="editDetail !== row.id && row.status !== 'Activo'">
                                    {{row.name}} ({{row.status}})
                                    <v-btn icon small @click="editDetail = row.id" class="grey--text">
                                      <v-icon small class="f0-9em">fas fa-pencil-alt</v-icon>
                                    </v-btn>
                                    <!-- <v-chip small class="white--text grey" v-if="item.status === 'Activo'">
                                      <v-icon class="pr-2" small>fas fa-times</v-icon>
                                      {{row.status}}
                                    </v-chip> -->
                                  </v-flex>
                                  <v-flex md12 class="f1-3em" px-2 v-if="editDetail === row.id">
                                    <v-layout justify-center align-center>
                                      <v-flex md12>
                                        <v-text-field
                                        color="black"
                                        label="Nombre de filtro"
                                        v-model="row.name"
                                        :error-messages="errors.collect('name')"
                                        v-validate="'required|max:100'"
                                        data-vv-name="name"
                                        data-vv-as="nombre"
                                        class="elevation-0"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex md3 pl-3>
                                        <v-text-field
                                        color="black"
                                        label="Orden"
                                        v-model="row.order"
                                        :error-messages="errors.collect('order')"
                                        v-validate="'required|numeric'"
                                        data-vv-name="order"
                                        data-vv-as="orden"
                                        class="elevation-0"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex md5 pl-3>
                                        <v-btn icon small @click="editDetail = false" class="grey--text">
                                          <v-icon small class="f0-9em">fas fa-times</v-icon>
                                        </v-btn>
                                        <v-btn icon small @click="setRowName(row.id, row.name, row.order)" class="grey--text">
                                          <v-icon small class="f0-9em">fas fa-check</v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex md7 pl-5>
                                    <v-menu offset-y>
                                      <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':row.send_sms == 1, 'a-borders k-grey-light-text':row.send_sms != 1}" icon>
                                        <v-icon small>fas fa-comments</v-icon>
                                      </v-btn>
                                      <template v-if="row.send_sms == 1">
                                        <v-list>
                                          <v-list-tile @click="getTemplates(row.id, row.template_id, 'sms')">
                                            <v-list-tile-title>Editar</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="openFilterChannel(row.id, 'sms')">
                                            <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="setRowFilter(row.id, 0, 'send_sms')">
                                            <v-list-tile-title>Desactivar</v-list-tile-title>
                                          </v-list-tile>
                                        </v-list>
                                      </template>
                                      <template v-else>
                                        <v-list>
                                          <v-list-tile @click="setRowFilter(row.id, 1, 'send_sms')">
                                            <v-list-tile-title>Activar</v-list-tile-title>
                                          </v-list-tile>
                                        </v-list>
                                      </template>
                                    </v-menu>
                                    <v-menu offset-y>
                                      <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':row.send_email == 1, 'a-borders k-grey-light-text':row.send_email != 1}" icon>
                                        <v-icon small>fas fa-envelope</v-icon>
                                      </v-btn>
                                      <template v-if="row.send_email == 1">
                                        <v-list>
                                          <v-list-tile @click="getTemplates(row.id, row.template_id, 'email')">
                                            <v-list-tile-title>Editar</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="setRowFilter(row.id, 0, 'send_email')">
                                            <v-list-tile-title>Desactivar</v-list-tile-title>
                                          </v-list-tile>
                                        </v-list>
                                      </template>
                                      <template v-else>
                                          <v-list-tile @click="setRowFilter(row.id, 1, 'send_email')">
                                            <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                          </v-list-tile>
                                        </template>
                                    </v-menu>
                                    <v-menu offset-y>
                                      <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':row.send_ivr == 1, 'a-borders k-grey-light-text':row.send_ivr != 1}" icon>
                                        <v-icon small>fas fa-phone fa-rotate-90</v-icon>
                                      </v-btn>
                                      <v-list>
                                        <template v-if="row.send_ivr == 1">
                                          <v-list-tile @click="getTemplates(row.id, row.template_id, 'ivr')">
                                            <v-list-tile-title>Editar</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="openFilterChannel(row.id, 'ivr')">
                                            <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="setRowFilter(row.id, 0, 'send_ivr')">
                                            <v-list-tile-title>Desactivar</v-list-tile-title>
                                          </v-list-tile>
                                        </template>
                                        <template v-else>
                                          <v-list-tile @click="setRowFilter(row.id, 1, 'send_ivr')">
                                            <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                          </v-list-tile>
                                        </template>
                                      </v-list>
                                    </v-menu>
                                    <v-menu offset-y>
                                      <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':row.send_bot == 1, 'a-borders k-grey-light-text':row.send_bot != 1}" icon>
                                        <v-icon small class="pb-1">fas fa-robot</v-icon>
                                      </v-btn>
                                      <v-list>
                                        <template v-if="row.send_bot == 1">
                                          <v-list-tile @click="getBotTemplates(row.id, row.bot_template_id)">
                                            <v-list-tile-title class="k-grey-text">Editar</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="openFilterChannel(row.id, 'bot')">
                                            <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="setRowFilter(row.id, 0, 'send_bot')">
                                            <v-list-tile-title class="k-grey-text">Desactivar</v-list-tile-title>
                                          </v-list-tile>
                                        </template>
                                        <template v-else>
                                          <v-list-tile @click="setRowFilter(row.id, 1, 'send_bot')">
                                            <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                          </v-list-tile>
                                        </template>
                                      </v-list>
                                    </v-menu>
                                    <v-menu offset-y>
                                      <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':row.send_human == 1, 'a-borders k-grey-light-text':row.send_human != 1}" icon>
                                        <v-icon small class="pb-1">fas fa-user</v-icon>
                                      </v-btn>
                                      <v-list>
                                        <template v-if="row.send_human === 1">
                                          <v-list-tile @click="openFilterChannel(row.id, 'human')">
                                            <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                          </v-list-tile>
                                          <v-list-tile @click="setRowFilter(row.id, 0, 'send_human')">
                                            <v-list-tile-title class="k-grey-text">Desactivar</v-list-tile-title>
                                          </v-list-tile>
                                        </template>
                                        <template v-else>
                                          <v-list-tile @click="setRowFilter(row.id, 1, 'send_human')">
                                            <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                          </v-list-tile>
                                        </template>
                                      </v-list>
                                    </v-menu>
                                    <v-menu offset-y>
                                      <v-btn icon slot="activator" class="k-orange-linear-underline" outline>
                                        <v-icon small class="k-orange-linear-text">fas fa-stream</v-icon>
                                      </v-btn>
                                      <v-list>
                                        <v-subheader>Probar plantilla</v-subheader>
                                        <v-divider></v-divider>
                                        <v-list-tile @click="doTest(row.template_id, `${row.name} sms`, 'sms')">
                                          <v-list-tile-title class="k-grey-text">SMS</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click="doTest(row.template_id, `${row.name} email`, 'email')">
                                          <v-list-tile-title class="k-grey-text">EMAIL</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click="doTest(row.template_id, `${row.name} ivr`, 'ivr')">
                                          <v-list-tile-title class="k-grey-text">IVR</v-list-tile-title>
                                        </v-list-tile>
                                      </v-list>
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex md12>
                                <v-layout row wrap pb-2>
                                  <template v-for="filter in filters">
                                    <template v-if="row[filter.value] && row[filter.value] !== null">
                                      <v-flex md4 px-1 :key="`${filter.value}-drop`" v-if="!filter.text">
                                        <v-menu offset-y class="w-100" max-height="250px">
                                          <v-chip slot="activator" small class="a-borders grey--text custom-chip transparent w-100">
                                            {{filter.label}} ({{getName(filter, row)}})
                                          </v-chip>
                                          <v-list v-if="lists[filter.list].length > 0">
                                            <v-list-tile v-for="(item, i) in lists[filter.list]" :key="i" @click="setRowFilter(row.id, item.value, filter.value)">
                                              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                            </v-list-tile>
                                          </v-list>
                                          <v-list v-else>
                                            <v-list-tile>
                                              <v-list-tile-title class="grey--text">No se encontraron registros</v-list-tile-title>
                                            </v-list-tile>
                                          </v-list>
                                        </v-menu>
                                      </v-flex>
                                      <!-- <v-flex md4 px-1 :key="`${filter.value}-text`" v-else>
                                        <v-menu offset-y class="w-100" max-height="250px" max-width="269px" :close-on-content-click="false">
                                          <v-chip slot="activator" small class="a-borders grey--text custom-chip transparent w-100" :id="`${filter.value}-${row.id}`">
                                            {{filter.label}} ({{row[filter.value] === null || row[filter.value] === 'Todos' || row[filter.value] === '' ? 'Todos' : row[filter.value]}})
                                          </v-chip>
                                          <v-list>
                                            <v-list-tile class="mt-3">
                                              <v-text-field
                                                :label="filter.label"
                                                v-model="row[filter.value]"
                                                color="black"
                                                :append-icon="row[filter.value] === null || row[filter.value] === 'Todos' || row[filter.value] === '' ? '' : 'close'"
                                                :append-icon-cb="() => (setRowFilter(row.id, 'Todos', filter.value, filter.value))"
                                                :error-messages="errors.collect(filter.value)"
                                                v-validate="'decimal'"
                                                :data-vv-name="filter.value"
                                                :data-vv-as="filter.name"
                                              ></v-text-field>
                                            </v-list-tile>
                                            <v-list-tile class="mt-1 mb-2">
                                              <v-btn small flat @click="closeMenu(row.id, filter.value)">CERRAR</v-btn>
                                              <v-btn small flat class="k-orange-linear-text" @click="setRowFilter(row.id, row[filter.value], filter.value, filter.value)">GUARDAR</v-btn>
                                            </v-list-tile>
                                          </v-list>
                                        </v-menu>
                                      </v-flex> -->
                                    </template>
                                  </template>
                                  <v-flex md4 px-1>
                                    <v-chip small class="a-borders grey--text custom-chip transparent w-100" @click="setFilterEdit(i, j)">
                                      Agregar filtro
                                    </v-chip>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex md1 class="text-xs-right">
                            <v-menu offset-x left>
                              <v-btn slot="activator" icon class="grey--text">
                                <v-icon class="f1-2em">fas fa-ellipsis-v</v-icon>
                              </v-btn>
                              <v-list>
                                <v-list-tile @click="setRowFilter(row.id, row.status === 'Activo' ? 'Inactivo' : 'Activo', 'status')" v-if="item.status === 'Activo'">
                                  <v-list-tile-title>{{row.status === 'Activo' ? 'Desactivar' : 'Activar'}}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="deleteWorkflowDetail(row.id, row.name)">
                                  <v-list-tile-title>Eliminar</v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                    </template>
                  </draggable>
                  <!-- End Filters Of Filter -->
                  <template v-if="createDetail === item.id">
                    <v-layout row wrap class="px-3 pt-3 pb-1">
                      <v-flex md1>
                        <v-icon class="mt-5 ml-4 f3-5em k-orange-linear-text">fas fa-code-branch fa-rotate-180</v-icon>
                      </v-flex>
                      <v-flex md11>
                        <v-layout row wrap>
                          <v-flex md12>
                            <v-layout row wrap pb-0>
                              <v-flex md4 class="f1-2em" px-2>
                                <v-text-field
                                  color="black"
                                  label="Nombre de filtro"
                                  v-model="form.name"
                                  :error-messages="errors.collect('name')"
                                  v-validate="'required|max:100'"
                                  data-vv-name="name"
                                  data-vv-as="nombre"
                                  class="elevation-0"
                                ></v-text-field>
                              </v-flex>
                              <v-flex md2 pl-3>
                                <v-text-field
                                  color="black"
                                  label="Orden"
                                  v-model="form.order"
                                  :error-messages="errors.collect('order')"
                                  v-validate="'required|numeric'"
                                  data-vv-name="order"
                                  data-vv-as="orden"
                                  class="elevation-0"
                                ></v-text-field>
                              </v-flex>
                              <v-flex md6 pl-5 pt-2>
                                <v-menu offset-y>
                                  <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':form.send_sms == 1, 'a-borders k-grey-light-text':form.send_sms != 1}" icon>
                                    <v-icon small>fas fa-comments</v-icon>
                                  </v-btn>
                                  <template v-if="form.send_sms == 1">
                                    <v-list>
                                      <v-list-tile @click="showDialog('sms')">
                                        <v-list-tile-title>Editar plantilla</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="openFilterChannel(null, 'sms')">
                                        <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="form.send_sms = 0">
                                          <v-list-tile-title class="k-grey-text">Desactivar</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                  </template>
                                  <template v-else>
                                    <v-list>
                                      <v-list-tile @click="form.send_sms = 1">
                                          <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                  </template>
                                </v-menu>
                                <v-menu offset-y>
                                  <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':form.send_email == 1, 'a-borders k-grey-light-text':form.send_email != 1}" icon>
                                    <v-icon small>fas fa-envelope</v-icon>
                                  </v-btn>
                                  <template v-if="form.send_email == 1">
                                    <v-list>
                                      <v-list-tile @click="showDialog('email')">
                                        <v-list-tile-title>Editar plantilla</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="form.send_email = 0">
                                          <v-list-tile-title class="k-grey-text">Desactivar</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                  </template>
                                  <template v-else>
                                    <v-list>
                                      <v-list-tile @click="form.send_email = 1">
                                          <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                  </template>
                                </v-menu>
                                <v-menu offset-y>
                                  <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':form.send_ivr == 1, 'a-borders k-grey-light-text':form.send_ivr != 1}" icon>
                                    <v-icon small>fas fa-phone fa-rotate-90</v-icon>
                                  </v-btn>
                                  <template v-if="form.send_ivr == 1">
                                    <v-list>
                                      <v-list-tile @click="showDialog('ivr')">
                                        <v-list-tile-title>Editar plantilla</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="openFilterChannel(null, 'ivr')">
                                        <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="form.send_ivr = 0">
                                          <v-list-tile-title class="k-grey-text">Desactivar</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                  </template>
                                  <template v-else>
                                    <v-list>
                                      <v-list-tile @click="form.send_ivr = 1">
                                        <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                      </v-list-tile>
                                    </v-list>
                                  </template>
                                </v-menu>
                                <v-menu offset-y>
                                  <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':form.send_bot == 1, 'a-borders k-grey-light-text':form.send_bot != 1}" icon>
                                    <v-icon small class="pb-1">fas fa-robot</v-icon>
                                  </v-btn>
                                  <v-list>
                                    <template v-if="form.send_bot == 1">
                                      <v-list-tile @click="getBotTemplates()">
                                        <v-list-tile-title class="k-grey-text">Seleccionar plantilla</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="openFilterChannel(null, 'bot')">
                                        <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="form.send_bot = 0">
                                        <v-list-tile-title class="k-grey-text">Desactivar</v-list-tile-title>
                                      </v-list-tile>
                                    </template>
                                    <template v-else>
                                      <v-list-tile @click="form.send_bot = 1">
                                        <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                      </v-list-tile>
                                    </template>
                                  </v-list>
                                </v-menu>
                                <v-menu offset-y>
                                  <v-btn slot="activator" :class="{'k-orange-linear-text k-orange-linear-underline':form.send_human == 1, 'a-borders k-grey-light-text':form.send_human != 1}" icon>
                                    <v-icon small class="pb-1">fas fa-user</v-icon>
                                  </v-btn>
                                  <v-list>
                                    <template v-if="form.send_human == 1">
                                      <v-list-tile @click="openFilterChannel(null, 'human')">
                                        <v-list-tile-title>Filtrar tipo</v-list-tile-title>
                                      </v-list-tile>
                                      <v-list-tile @click="form.send_human = 0">
                                        <v-list-tile-title class="k-grey-text">Desactivar</v-list-tile-title>
                                      </v-list-tile>
                                    </template>
                                    <template v-else>
                                      <v-list-tile @click="form.send_human = 1">
                                        <v-list-tile-title class="k-grey-text">Activar</v-list-tile-title>
                                      </v-list-tile>
                                    </template>
                                  </v-list>
                                </v-menu>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex md12>
                            <v-layout row wrap pb-2>
                              <template v-for="filter in filters">
                                <template v-if="filter.set">
                                  <v-flex md4 px-1 :key="`${filter.value}-drop`" v-if="form[filter.value] != null">
                                    <v-menu offset-y class="w-100" max-height="250px">
                                      <v-chip slot="activator" small class="a-borders grey--text custom-chip white-no-border w-100">
                                        {{filter.label}} ({{getName(filter, form)}})
                                      </v-chip>
                                      <v-list v-if="lists[filter.list].length > 0">
                                        <v-list-tile v-for="(item, i) in lists[filter.list]" :key="i" @click="form[filter.value] = item.value">
                                          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                        </v-list-tile>
                                      </v-list>
                                      <v-list v-else>
                                        <v-list-tile>
                                          <v-list-tile-title class="grey--text">No se encontraron registros</v-list-tile-title>
                                        </v-list-tile>
                                      </v-list>
                                    </v-menu>
                                  </v-flex>
                                  <!-- <v-flex md4 px-1 :key="`${filter.value}-text`" v-else>
                                    <v-menu offset-y class="w-100" max-height="250px" max-width="269px" :close-on-content-click="false">
                                      <v-chip slot="activator" small class="a-borders grey--text custom-chip white-no-border w-100" :id="`${filter.value}-create`">
                                        {{filter.label}} ({{form[filter.value] === null || form[filter.value] === 'Todos' || form[filter.value] === '' ? 'Todos' : form[filter.value]}})
                                      </v-chip>
                                      <v-list>
                                        <v-list-tile class="mt-3">
                                          <v-text-field
                                            :label="filter.label"
                                            v-model="form[filter.value]"
                                            color="black"
                                            :append-icon="form[filter.value] === null || form[filter.value] === 'Todos' || form[filter.value] === '' ? '' : 'close'"
                                            :append-icon-cb="() => (form[filter.value] = '')"
                                            :error-messages="errors.collect(filter.value)"
                                            v-validate="'decimal'"
                                            :data-vv-name="filter.value"
                                            :data-vv-as="filter.name"
                                          ></v-text-field>
                                        </v-list-tile>
                                        <v-list-tile class="mt-1 mb-2">
                                          <v-btn small flat @click="closeMenu('create', filter.value)">CERRAR</v-btn>
                                        </v-list-tile>
                                      </v-list>
                                    </v-menu>
                                  </v-flex> -->
                                </template>
                              </template>
                              <v-flex md4 px-1>
                                <v-chip small class="a-borders grey--text custom-chip white-no-border w-100" @click="filterDialog = true">
                                  Agregar filtro
                                </v-chip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-layout justify-center align-center my-3>
                    <v-flex md12 class="text-xs-center">
                      <v-btn flat large @click="createDetail = false" v-if="createDetail === item.id">CERRAR</v-btn>
                      <v-btn flat large class="k-orange-linear-text" @click="!createDetail ? createFormDetail(item.id) : sendDetail()">{{createDetail ? 'Guardar detalle' : 'Agregar detalle'}}</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center align-center my-3>
                    <v-flex md12 class="text-xs-center">
                      <v-btn flat large icon @click="showFilters = false">
                        <v-icon>fas fa-angle-up</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>
              </v-card-text>
            </v-card>
            <v-card v-else class="x-borders-radius">
              <v-card-text>
                <v-layout row wrap px-3>
                  <v-flex md12 class="py-3 f1-4em">
                    Editar etapa de cobranza
                  </v-flex>
                </v-layout>
                <v-layout row wrap px-4 mx-2>
                  <v-flex md4 pr-4>
                    <v-text-field
                      color="black"
                      label="Inicio de mora"
                      v-model="item.delinquency_start"
                      :error-messages="errors.collect('delinquency_start')"
                      v-validate="'required|max:100'"
                      data-vv-name="delinquency_start"
                      data-vv-as="inicio del flujo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 px-4>
                    <v-text-field
                      color="black"
                      label="Fin de mora"
                      v-model="item.delinquency_end"
                      :error-messages="errors.collect('delinquency_end')"
                      v-validate="'required|max:100'"
                      data-vv-name="delinquency_end"
                      data-vv-as="fin del flujo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 pl-4>
                    <v-text-field
                      color="black"
                      label="Ventana de tiempo"
                      v-model="item.days_off"
                      :error-messages="errors.collect('days_off')"
                      v-validate="'required|max:100'"
                      data-vv-name="days_off"
                      data-vv-as="ventana de tiempo"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md12 class="text-xs-center">
                    <v-btn flat large @click="editWorkflow = false">CERRAR</v-btn>
                    <v-btn flat large @click="updateWorkflow(item)" class="k-orange-linear-text">GUARDAR</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="vertical-divider l-borders" :key="`${i}-divider`">

        </v-layout>
      </template>
    </template>
    <v-layout row wrap mx-5 :class="{'mt-3':workflowNotifications.length === 0}">
      <v-flex md12>
        <v-card class="hovered x-borders-radius" v-if="!createWorkflow">
          <v-card-text @click="createWorkflow = !createWorkflow">
            <v-layout row wrap>
              <v-flex md12 class="py-3 text-xs-center">
                <v-icon class="f3-5em k-orange-linear-text">fas fa-plus-circle</v-icon>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card v-else class="x-borders-radius">
          <v-card-text>
            <v-layout row wrap px-3>
              <v-flex md12 class="py-3 f1-4em">
                Agregar etapa de cobranza
              </v-flex>
            </v-layout>
            <v-layout row wrap px-4 mx-2>
              <v-flex md4 pr-4>
                <v-text-field
                  color="black"
                  label="Inicio de mora"
                  v-model="form.delinquency_start"
                  :error-messages="errors.collect('delinquency_start')"
                  v-validate="'required|max:100'"
                  data-vv-name="delinquency_start"
                  data-vv-as="inicio del flujo"
                ></v-text-field>
              </v-flex>
              <v-flex md4 px-4>
                <v-text-field
                  color="black"
                  label="Fin de mora"
                  v-model="form.delinquency_end"
                  :error-messages="errors.collect('delinquency_end')"
                  v-validate="'required|max:100'"
                  data-vv-name="delinquency_end"
                  data-vv-as="fin del flujo"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pl-4>
                <v-text-field
                  color="black"
                  label="Ventana de tiempo"
                  v-model="form.days_off"
                  :error-messages="errors.collect('days_off')"
                  v-validate="'required|max:100'"
                  data-vv-name="days_off"
                  data-vv-as="ventana de tiempo"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12 class="text-xs-center">
                <v-btn flat large @click="createWorkflow = !createWorkflow">CERRAR</v-btn>
                <v-btn flat large @click="sendWorkflow()" class="k-orange-linear-text">GUARDAR</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <delete-dialog
      :dialog="deleteOptions.dialog"
      :id="deleteOptions.id"
      :text="deleteOptions.text"
      :url="route">
    </delete-dialog>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :max-width="template.channel ? '800px' : '1000px'"
      transition="dialog-transition">
      <v-card>
        <v-toolbar class="k-orange-linear white--text" flat>
          <v-toolbar-title>{{template.channel ? template.channel.toUpperCase() : 'BOT'}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-icon class="white--text">
            {{template.channel ? template.channel === 'sms' ? 'fas fa-phone fa-rotate-90' : template.channel === 'email' ? 'fas fa-envelope' : 'fas fa-comments' : 'fas fa-robot'}}
          </v-icon>
        </v-toolbar>
        <v-card-text class="px-5 py-4">
          <v-layout justify-center align-center>
            <v-flex md12 px-3 pt-2 pb-4>
              <v-select
              :items="templates"
              v-model="template"
              item-text="name"
              item-value="id"
              return-object
              class="elevation-0 transparent a-borders"
              color="grey"
              solo
              ></v-select>
            </v-flex>
          </v-layout>
          <div class="px-3 py-2 subheading k-grey-text" v-if="template.channel" v-html="template.text"></div>
          <template v-for="detail in template.bot_template_details" v-else>
            <template v-if="detail.name === 'text_1' || detail.name === 'text_2' || detail.name === 'text_4' || detail.name === 'text_5' || detail.name === 'text_8' || detail.name === 'text_9'">
              <div class="px-3 py-3 white-no-border w-50 text-xs-center a-borders elevation-5 x-borders-radius">
                <p class="pt-2 f1-2em" v-if="detail.name === 'text_1'">Saludo inicial</p>
                <p class="pt-2 f1-2em" v-if="detail.name === 'text_2'">Confirmación del cliente</p>
                <p class="pt-2 f1-2em" v-if="detail.name === 'text_4'">Mensaje de cobro</p>
                <p class="pt-2 f1-2em" v-if="detail.name === 'text_5'">Compromiso de pago</p>
                <p class="pt-2 f1-2em" v-if="detail.name === 'text_8'">Fecha de compromiso</p>
                <p class="pt-2 f1-2em" v-if="detail.name === 'text_9'">Despedida</p>
                <p class="k-grey-text">{{detail.text}}</p>
              </div>
              <div :class="{'l-borders':true, 'vertical-divider-template-100':detail.name !== 'text_2' && detail.name !== 'text_5' && detail.name !== 'text_9'}">

              </div>
            </template>
            <template v-else-if="detail.name.split('_')[0] !== 'fallback' && detail.name !== 'text_6'">
              <v-layout justify-center align-center>
                <v-flex md4 class="l-borders h-160px ml-25">
                  <v-layout row wrap>
                    <v-flex md12 class="h-80px">

                    </v-flex>
                    <v-flex md12 class="t-borders h-80px">

                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md5 class="px-3 py-3 a-borders elevation-5 x-borders-radius text-xs-center">
                  <p class="pt-2 f1-2em" v-if="detail.name === 'text_3'">Cliente equivocado</p>
                  <p class="pt-2 f1-2em" v-if="detail.name === 'text_7'">Despedida</p>
                  <p class="k-grey-text">{{detail.text}}</p>
                </v-flex>
              </v-layout>
            </template>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-flex md12 class="text-xs-right">
            <v-btn flat @click="dialog = false">CERRAR</v-btn>
            <v-btn v-if="!createDetail" flat class="k-orange-linear-text" @click="setRowFilter(workflowNotificationDetailId, template.id, 'bot_template_id')">GUARDAR</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filterDialog"
      scrollable
      persistent
      max-width="400px"
      transition="dialog-transition">
      <v-card>
        <v-toolbar class="k-orange-linear white--text">
          <v-toolbar-title>
            Seleccione los filtros
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-list class="pa-0">
            <template v-if="workflowNotifications[workflowFilterIndex] || createDetail">
              <v-list-tile avatar v-for="(filter, i) in filters" :key="i">
                <v-list-tile-title>
                  <v-layout row wrap>
                    <v-flex md10>
                      {{filter.label}}
                    </v-flex>
                    <v-flex md2 v-if="!createDetail">
                      <v-checkbox v-model="filter.set" v-if="workflowNotifications[workflowFilterIndex].workflow_filters[filterIndex][filter.value] === null ||
                        workflowNotifications[workflowFilterIndex].workflow_filters[filterIndex][filter.value] === 0 ||
                        workflowNotifications[workflowFilterIndex].workflow_filters[filterIndex][filter.value] === false ||
                        workflowNotifications[workflowFilterIndex].workflow_filters[filterIndex][filter.value] === 'Todos'" class="k-orange-linear-text" @change="getFilter(filter.value, filter.set)"></v-checkbox>
                      <v-checkbox v-else class="k-orange-linear-text" input-value="true" value></v-checkbox>
                    </v-flex>
                    <v-flex md2 v-else>
                      <v-checkbox v-model="filter.set" class="k-orange-linear-text"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex md12 class="text-xs-right">
              <v-btn flat @click="filterDialog = false">Cerrar</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filterChannel"
      scrollable
      persistent
      max-width="350px"
      transition="dialog-transition">
      <v-card>
        <v-toolbar class="k-orange-linear white--text">
          <v-toolbar-title>
            Seleccione los tipos
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-list v-if="filterChannel && dontSave" class="pl-4 mt-4">
            <v-list-tile avatar>
              <v-layout row wrap>
                <v-flex md9>
                  Celular
                </v-flex>
                <v-flex md3>
                  <v-checkbox v-model="form.filtersType[channelFilter].celular"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-list-tile>
            <v-list-tile avatar>
              <v-layout row wrap>
                <v-flex md9>
                  Fijo
                </v-flex>
                <v-flex md3>
                  <v-checkbox v-model="form.filtersType[channelFilter].fijo"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-list-tile>
            <v-list-tile avatar>
              <v-layout row wrap>
                <v-flex md9>
                  Referido
                </v-flex>
                <v-flex md3>
                  <v-checkbox v-model="form.filtersType[channelFilter].referido"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-list-tile>
          </v-list>
          <v-list v-if="filterChannel && !dontSave" class="pl-4 mt-4">
            <v-list-tile avatar>
              <v-layout row wrap>
                <v-flex md9>
                  Celular
                </v-flex>
                <v-flex md3>
                  <v-checkbox v-model="workflowContactTypes[channelFilter].celular"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-list-tile>
            <v-list-tile avatar>
              <v-layout row wrap>
                <v-flex md9>
                  Fijo
                </v-flex>
                <v-flex md3>
                  <v-checkbox v-model="workflowContactTypes[channelFilter].fijo"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-list-tile>
            <v-list-tile avatar>
              <v-layout row wrap>
                <v-flex md9>
                  Referido
                </v-flex>
                <v-flex md3>
                  <v-checkbox v-model="workflowContactTypes[channelFilter].referido"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex md12 class="text-xs-right">
              <v-btn flat @click="filterChannel = false">Cerrar</v-btn>
              <v-btn flat @click="!dontSave ? saveFilterChannel(channelFilter, workflowContactTypes[channelFilter]) : filterChannel = false">Guardar</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FormModal :channel="channel" type="workflow_notification"></FormModal>
    <FormModalEmail type="workflow_notification"></FormModalEmail>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import EventBus from '@/event-bus';
import saveDialogMixin from '@/mixins/saveDialog';
import deleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import dataTableListMixin from '@/mixins/dataTableList';
import FormModal from '@/components/templateV2/FormModal';
import FormModalEmail from '@/components/templateV2/FormModalEmail';

export default {
  mixins: [
    dataTableListMixin,
    saveDialogMixin,
    deleteDialogMixin,
  ],
  components: {
    deleteDialog,
    FormModal,
    FormModalEmail,
    draggable,
  },
  data() {
    return {
      filterDialog: false,
      filterChannel: false,
      showFilters: false,
      workflow: {},
      channel: 'sms',
      render: false,
      filters: [
        {
          label: 'Refi. Parcial',
          value: 'partial_refinancing',
          list: 0,
          set: false,
        },
        {
          label: 'Refi. Total',
          value: 'total_refinancing',
          list: 1,
          set: false,
        },
        {
          label: 'Dia de vencimiento',
          value: 'due_day_id',
          list: 2,
          set: false,
        },
        {
          label: 'Tramo de mora',
          value: 'tranche_id',
          list: 3,
          set: false,
        },
        {
          label: 'Agencia',
          value: 'agency_id',
          list: 4,
          set: false,
        },
        {
          label: 'Estado de clientes',
          value: 'customer_status_id',
          list: 5,
          set: false,
        },
        {
          label: 'Tarjeta',
          value: 'account_type_id',
          list: 6,
          set: false,
        },
        {
          label: 'Cartera',
          value: 'portfolio_type_id',
          list: 7,
          set: false,
        },
        {
          label: 'Sexo',
          value: 'gender',
          list: 8,
          set: false,
        },
      ],
      editName: false,
      lists: [
        [ // total_refinancing
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // partial_refinancing
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // due_day
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // tranche
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // agency
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // customer_status
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // account_type
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // portfolio_type
          {
            value: null,
            name: 'Todos',
          },
        ],
        [ // gender
          {
            value: null,
            name: 'Todos',
          },
        ],
      ],
      pred_payment: '',
      pred_default: '',
      dialog: false,
      templates: [],
      template: {},
      tranches: [],
      editWorkflow: false,
      createWorkflow: false,
      createDetail: false,
      editDetail: false,
      workflowFilterIndex: false,
      filterIndex: false,
      workflowFilterId: 0,
      workflowNotificationId: 0,
      workflowNotificationDetailId: 0,
      workflowNotificationDetailIdTemplate: 0,
      workflowNotifications: [],
      showName: 'detalle de flujo',
      route: 'workflow_filters',
      fields: 'name',
      channelFilter: '',
      form: {
        name: '',
        order: 0,
        workflow_stage_id: 0,
        account_type_id: null,
        portfolio_type_id: null,
        total_refinancing: null,
        partial_refinancing: null,
        pred_payment: null,
        pred_default: null,
        customer_status_id: null,
        filtersType: {
          sms: {
            celular: false,
            fijo: false,
            referido: false,
          },
          bot: {
            celular: false,
            fijo: false,
            referido: false,
          },
          ivr: {
            celular: false,
            fijo: false,
            referido: false,
          },
          human: {
            celular: false,
            fijo: false,
            referido: false,
          },
        },
        gender: null,
        due_day_id: null,
        tranche_id: null,
        seniority: null,
        send_human: null,
        send_ivr: null,
        send_sms: null,
        send_email: null,
        send_bot: null,
        agency_id: null,
        bot_template_id: 0,
      },
      workflowContactTypes: {
        sms: {
          celular: false,
          fijo: false,
          referido: false,
        },
        bot: {
          celular: false,
          fijo: false,
          referido: false,
        },
        ivr: {
          celular: false,
          fijo: false,
          referido: false,
        },
        human: {
          celular: false,
          fijo: false,
          referido: false,
        },
      },
      dontSave: false,
    };
  },
  mounted() {
    EventBus.$on('formData', (form) => {
      this.form[this.channel !== 'email' ? this.channel : 'text'] = form[this.channel !== 'email' ? this.channel : 'text'];
      if (form.channel === 'ivr') {
        this.form.voice = form.voice;
      } else if (form.channel === 'email') {
        this.form.from = form.from;
        this.form.subject = form.subject;
      }
    });
    EventBus.$on('created', () => {
      this.getWorkflowNotification(true);
    });
    EventBus.$on('updated', () => {
      this.getWorkflowNotification(true);
    });
    EventBus.$on('deleted', () => {
      this.getWorkflowNotification(true);
    });
    EventBus.$on('modalOpened', () => {
      if (this.route === 'workflow_stages' || this.route === `workflow_stages/${this.workflowNotificationId}`) {
        this.hasWorkflowDetailMore = false;
      }
    });
    this.getWorkflow();
    this.getWorkflowNotification();
    this.getFilters();
  },
  beforeDestroy() {
    EventBus.$off('created');
    EventBus.$off('updated');
    EventBus.$off('deleted');
    EventBus.$off('modalOpened');
    EventBus.$off('formData');
  },
  methods: {
    drag(e, i) {
      this.changeOrder(e.moved.element.id, this.workflowNotifications[i].workflow_filters[e.moved.oldIndex].order); // eslint-disable-line
      this.changeOrder(this.workflowNotifications[i].workflow_filters[e.moved.oldIndex].id, e.moved.element.order, true); // eslint-disable-line
    },
    getName(filter, row) {
      const val = this.lists[filter.list].find(obj => obj.value === row[filter.value]) || { name: 'Todos' };
      return val.name;
    },
    changeOrder(id, order, update = null) {
      this.axios.patch(`workflow_filters/${id}`, {
        order,
      }).then(() => {
        if (update) {
          this.getWorkflowNotification();
        }
      }).catch((e) => {
        EventBus.$emit('modal', e.response.data);
      });
    },
    showDialog(channel) {
      this.channel = channel;
      this.$nextTick(() => {
        // eslint-disable-next-line
        EventBus.$emit(`createTemplate${channel === 'email' ? 'email' : channel === 'bot' ? 'bot' : ''}`, channel);
      });
    },
    getFilters() {
      this.axios.get('customers/filters').then((response) => {
        /* eslint-disable */
        response.data.partialRefinancing !== null ? this.lists[0] = this.lists[0].concat(response.data.partialRefinancing) : '';
        response.data.totalRefinancing !== null ? this.lists[1] = this.lists[1].concat(response.data.totalRefinancing) : '';
        response.data.dueDays !== null ? this.lists[2] = this.lists[2].concat(response.data.dueDays) : '';
        response.data.tranche !== null ? this.lists[3] = this.lists[3].concat(response.data.tranche) : '';
        response.data.agency !== null ? this.lists[4] = this.lists[4].concat(response.data.agency) : '';
        response.data.status !== null ? this.lists[5] = this.lists[5].concat(response.data.status) : '';
        response.data.accountType !== null ? this.lists[6] = this.lists[6].concat(response.data.accountType) : '';
        response.data.portfolioType !== null ? this.lists[7] = this.lists[7].concat(response.data.portfolioType) : '';
        response.data.gender !== null ? this.lists[8] = this.lists[8].concat(response.data.gender) : '';
        this.render = true;
      });
    },
    getWorkflow() {
      this.axios.get(`/workflow_notifications/${this.$route.params.workflowNotification}`).then((response) => {
        this.workflow = response.data;
      });
    },
    getTemplates(idRow, idTemplate, channel) {
      this.channel = channel; // eslint-disable-line
      EventBus.$emit(`editItemTemplate${channel !== 'email' ? '' : 'email'}`, idTemplate);
    },
    getBotTemplates(idRow = null, idTemplate = null) {
      this.workflowNotificationDetailId = idRow;
      this.workflowNotificationDetailIdTemplate = idTemplate;
      if (idRow !== null && idTemplate !== null) {
        this.axios.get('bot_templates?fields=text,name,id,botTemplateDetails.name,botTemplateDetails.text&paginate=0&status=activo').then((response) => {
          this.templates = response.data;
          this.template = response.data.find(item => item.id === idTemplate);
          this.dialog = true;
        });
      } else {
        this.axios.get('bot_templates?fields=text,name,id,botTemplateDetails.name,botTemplateDetails.text&paginate=0&status=activo').then((response) => {
          this.templates = response.data;
          this.template = response.data[0];
          this.dialog = true;
        });
      }
    },
    getWorkflowNotification(update = null) {
      this.axios.get(`workflow_stages?workflow_notification_id=${this.$route.params.workflowNotification}`).then((response) => { // eslint-disable-line
        this.workflowNotifications = response.data;
        if (update !== null) {
          this.editWorkflow = false;
          this.createWorkflow = false;
          this.editDetail = false;
          this.createDetail = false;
        }
      });
    },
    deleteWorkflow(id, name, detailsLength) {
      if (detailsLength === 0) {
        this.route = 'workflow_stages';
        this.deleteOptions.id = id;
        this.deleteOptions.text = name;
        this.deleteOptions.dialog = true;
      } else {
        EventBus.$emit('modal', 'No se puede eliminar una etapa con filtros');
      }
    },
    deleteWorkflowDetail(id, name) {
      this.route = 'workflow_filters';
      this.deleteOptions.id = id;
      this.deleteOptions.text = name;
      this.deleteOptions.dialog = true;
    },
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          if (key.slice(0, 5) !== 'send_' && key !== 'workflow_stage_id' && key !== 'filtersType') { // eslint-disable-line
            this.form[key] = '';
          } else if (key === 'human') {
            this.form[key] = 0;
          } else if (key === 'filtersType') {
            Object.keys(this.form.filtersType).forEach((key2) => {
              Object.keys(this.form.filtersType[key2]).forEach((key3) => {
                this.form.filtersType[key2][key3] = false;
              });
            });
          } else if (key.slice(0, 5) === 'send_') {
            this.form[key] = 0;
          }
        }
      });
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
    },
    sendDetail() {
      Object.keys(this.form).forEach((key) => {
        if (this.form[key] === 'Todos') {
          this.form[key] = null;
        }
      });
      this.axios.post('workflow_filters', this.form).then(() => {
        EventBus.$emit('created');
        this.clearForm();
      });
    },
    createFormDetail(id) {
      this.clearForm();
      this.form.account_type = 'Todos';
      this.form.portfolio_type = 'Todos';
      this.form.total_refinancing = 'Todos';
      this.form.partial_refinancing = 'Todos';
      this.form.workflow_stage_id = id;
      this.createDetail = id;
    },
    /* eslint-disable */
    setRowFilter(idRow, itemFilter, typeFilter, idItem = null) {
      if (itemFilter === 'Todos' || itemFilter === 'No') {
        itemFilter = null;
      }
      this.workflowNotifications.forEach((item) => {
        let obj = item.workflow_filters.find(filter => filter.id === idRow);
        obj ? obj[typeFilter] = itemFilter : '';
      });
      this.axios.patch(`workflow_filters/${idRow}`, {
        [typeFilter]: itemFilter,
      }).then(() => {
        if (typeFilter === 'send_bot' || typeFilter === 'send_human' || typeFilter === 'send_ivr' || typeFilter === 'send_email' || typeFilter === 'send_sms') {
          EventBus.$emit('updated');
        }
        if (idItem) {
          document.getElementById(`${idItem}-${idRow}`).click();
        }
      });
    },
    /* eslint-enable */
    setRowName(idRow, name, order) {
      this.axios.patch(`workflow_filters/${idRow}`, {
        name,
        order,
      }).then(() => {
        EventBus.$emit('updated');
      });
    },
    sendWorkflow() {
      this.form.workflow_notification_id = this.$route.params.workflowNotification;
      this.axios.post('workflow_stages', this.form).then(() => {
        EventBus.$emit('created');
      });
    },
    updateWorkflow(item) {
      const form = {
        name: item.name,
        delinquency_start: item.delinquency_start,
        delinquency_end: item.delinquency_end,
        days_off: item.days_off,
      };
      this.axios.patch(`workflow_stages/${item.id}`, form).then(() => {
        EventBus.$emit('updated');
      });
    },
    doTest(id, code, channel) {
      EventBus.$emit('testTemplate', channel, id, code);
    },
    closeMenu(id, idItem) {
      document.getElementById(`${idItem}-${id}`).click();
    },
    changeStatus(id, status) {
      this.axios.patch(`workflow_stages/${id}`, {
        status,
      }).then(() => {
        this.getWorkflowNotification();
      }).catch(() => { });
    },
    getFilter(value, set) {
      // eslint-disable-next-line
      this.workflowNotifications[this.workflowFilterIndex].workflow_filters[this.filterIndex][value] = set;
    },
    setFilterEdit(Index1, Index2) {
      this.filters.forEach((item) => {
        item.set = false; // eslint-disable-line
      });
      this.workflowFilterIndex = Index1;
      this.filterIndex = Index2;
      this.filterDialog = true;
    },
    clearObject(obj) {
      /* eslint-disable */
      Object.keys(obj).forEach((key) => {
        obj[key] = false;
      });
      /* eslint-enable */
    },
    openFilterChannel(id, channel) {
      if (id != null) {
        this.clearForm();
        this.clearObject(this.workflowContactTypes[channel]);
        this.dontSave = false;
        this.workflowFilterId = id;
        this.axios.get(`/workflow_filters/${this.workflowFilterId}`).then((response) => {
          const contactTypes = JSON.parse(response.data.contact_types);
          if (contactTypes !== null && contactTypes[channel] != null) {
            this.workflowContactTypes[channel] = contactTypes[channel];
            this.channelFilter = channel;
            this.filterChannel = true;
          } else {
            this.channelFilter = channel;
            this.filterChannel = true;
          }
        });
      } else {
        this.dontSave = true;
        this.channelFilter = channel;
        this.filterChannel = true;
      }
    },
    saveFilterChannel(channel, item) {
      this.axios.patch(`/workflow_filters/${this.workflowFilterId}`, {
        set_filter: channel,
        filters: item,
      }).then(() => {
        this.filterChannel = false;
      }).catch(() => {
        this.filterChannel = false;
      });
    },
  },
  watch: {
    template(val) {
      if (this.createDetail) {
        this.form.bot_template_id = val.id;
      }
    },
    createDetail(val) {
      if (val) {
        this.editDetail = false;
      }
    },
    detailDetail(val) {
      if (val) {
        this.createDetail = false;
      }
    },
    createWorkflow() {
      this.clearForm();
    },
    workflowNotificationId(val) {
      this.form.workflow_stage_id = val;
    },
  },
};
</script>

<style scoped>
.layout.hovereable:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.1);
}

.a-borders.grey--text.custom-chip {
  color: #757575 !important;
  border-color: #BDBDBD !important;
}

.a-borders.grey--text:not(.custom-chip) {
  color: #BDBDBD !important;
  border-color: #BDBDBD !important;
}

.custom-divider {
  width:calc(100% - 40px) !important;
  margin-left: 20px !important;
}

.w-50 {
  width:50% !important;
}

.ml-25 {
  margin-left: 25% !important;
}

.h-160px {
  height:160px !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  border-top-width: 2px !important;
}

.h-80px {
  height:80px !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  border-top-width: 2px !important;
}

.card.hovered:hover {
  cursor: pointer;
  background: rgba(0,0,0,.05) !important;
  transition:0.2s ease-in;
}

.vertical-divider-template-50 {
  height: 50px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  border-top-width: 2px !important;
  margin-left: 25% !important;
}

.vertical-divider-template-100 {
  height: 160px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  margin-left: 25% !important;
}

.vertical-divider {
  height: 100px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 2px !important;
  margin-left: 50% !important;
}

.cursor-button:hover {
  cursor:pointer;
  color:rgba(0,0,0,0.5) !important;
}

.detail-table:hover {
  cursor:pointer;
  background-color: rgba(0,0,0,0.1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workflow_notification/WorkflowStages.vue